import Select from './Select'
import SelectOption from './SelectOptions'
export * from './Select.types'
export default Object.assign(Select, {
  Option: SelectOption,
})
